import { createContext } from "react";
var MainContext = createContext({
    featureFlags: { isNotificationsEnabled: false, isIRLEnabled: true },
    isRegistered: true,
    helpNumber: "",
    selectedAccountId: "",
});
export default MainContext;
//# sourceMappingURL=Context.js.map